/**
 * Tidio Chat Widget Integration (Optimized)
 * Lazy loads Tidio script only when a chat button is clicked.
 * Hides the default Tidio widget and allows opening via custom buttons.
 */

(function() {
  'use strict';

  var tidioKey = 'qw6aykvyt78adziw6hprfhi2b3wwikyb';
  var tidioScriptUrl = '//code.tidio.co/' + tidioKey + '.js';
  var isLoaded = false;

  function loadTidio() {
    if (isLoaded) return;
    isLoaded = true;

    var script = document.createElement('script');
    script.src = tidioScriptUrl;
    script.async = true;
    document.body.appendChild(script);
  }

  function onTidioChatApiReady() {
    if (window.tidioChatApi) {
      // Hide default widget as per original logic
      window.tidioChatApi.hide();
      window.tidioChatApi.on('close', function() {
        window.tidioChatApi.hide();
      });
    }
  }

  // Listen for Tidio ready event
  document.addEventListener('tidioChat-ready', onTidioChatApiReady);

  function initTidioChat() {
    // Handle custom chat buttons
    function handleChatButtons() {
      var chatButtons = document.querySelectorAll('[data-tidio-chat-button]');
      chatButtons.forEach(function(button) {
        // Clone to remove old listeners/duplicates
        var newButton = button.cloneNode(true);
        button.parentNode.replaceChild(newButton, button);
        
        newButton.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          
          loadTidio();
          
          // Poll for API ready and open
          var attempts = 0;
          var checkInterval = setInterval(function() {
            attempts++;
            if (window.tidioChatApi) {
              clearInterval(checkInterval);
              window.tidioChatApi.show();
              window.tidioChatApi.open();
            } else if (attempts > 300) { // 30 seconds timeout
              clearInterval(checkInterval);
            }
          }, 100);
        });
      });
    }

    // Initialize buttons when DOM is ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', handleChatButtons);
    } else {
      handleChatButtons();
    }

    // Handle dynamically added buttons (e.g., in accordions)
    var observer = new MutationObserver(function(mutations) {
      var shouldReinit = false;
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) { // Element node
            if (node.matches && node.matches('[data-tidio-chat-button]')) {
              shouldReinit = true;
            } else if (node.querySelector && node.querySelector('[data-tidio-chat-button]')) {
              shouldReinit = true;
            }
          }
        });
      });
      if (shouldReinit) {
        handleChatButtons();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  initTidioChat();
})();
